<template>
  <div class="right-pane aura-iframe-wrapper"
       :class="{ opened }"
       v-if="auraPanelEnabled">
    <div class="container" style="height: 50px; background: #181a1b">
      <div class="text-right">
        <a @click="toggleJetAPIChat"
           class="d-inline-flex pointer py-3">
          <CloseSvg class="svg-light svg-size-md"/>
        </a>
      </div>
    </div>
    <iframe v-if="fullIframeUrl"
            :src="fullIframeUrl"
            class="aura-iframe"></iframe>
  </div>
</template>

<script setup>
import CloseSvg from '@/assets/svg-vue/general/close.svg'
import { computed, ref, watch } from "vue"
import { useStore } from "vuex"
import { CRMService } from "@/services/api/crm.api.service"

const store = useStore()

const opened = computed(() => store.state.dom.rightPaneOpened)
const auraPanelEnabled = computed(() => store.getters.auraPanelEnabled)
const phone = computed(() => store.state.dom.phoneForJetApi?.phone || '')
const fullIframeUrl = ref('')

const toggleJetAPIChat = () => {
  store.state.dom.rightPaneOpened = !store.state.dom.rightPaneOpened
}

watch(opened, async (val) => {
  if(!auraPanelEnabled.value) return
  if(!val) {
    store.state.dom.phoneForJetApi = null
  }
  if (val) {
    try {
      const res = await CRMService.getAuraIframeUrl(phone.value)
      fullIframeUrl.value = res.data
    } catch (e) {
      fullIframeUrl.value = ''
      console.log(e)
    }
  }
})
</script>

<style>
.right-pane {
  position: fixed;
  right: 0;
  width: 0;
  height: 100vh;
  top: 0;
  background: #fff;
  z-index: 10;
  border-left: 1px solid #dee2e6;
  transition: width 0.2s;
  &.opened {
    width: 460px;
  }
}
.aura-iframe {
  width: 100%;
  border: none;
  height: calc(100vh - 50px);
}
@media screen and (max-width: 768px) {
  .right-pane {
    &.opened {
      width: 100%;
    }
  }
}
</style>
